module.exports = __webpack_public_path__ + "027641a508831d9430f812049a41e8b3.png";